import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';

import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { DialogService } from 'primeng/dynamicdialog';

import { templateTypes } from 'app/constants/templates/template-type';
import { time, messages } from 'app/constants';
import { DataService, HTTPService, HelperService, DateService } from 'app/services';
import { UpdateRecipientDialogComponent } from '../update-recipient-dialog/update-recipient-dialog.component';
import { currency } from 'app/constants/currency.constants';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-send-statement-dialog',
  templateUrl: './send-statement-dialog.component.html',
  styleUrls: ['./send-statement-dialog.component.scss'],
  providers: [DialogService],
})
export class SendStatementDialogComponent implements OnInit {
  card: any = {
    messages: {
      heading: 'Display Messages',
      content: 'Allow customers to view messages on estimates and invoices.',
      switch: false,
    },
    feed: {
      heading: 'Display Activity Feed',
      content: 'Allow customers to view messages on estimates and invoices.',
      switch: false,
    },
    schedule: {
      heading: 'Schedule pick up',
      content: 'Schedule pick up time for your customer',
      switch: true,
    },
    reminders: {
      heading: 'Reminder',
      content: 'Send the customer reminder on',
      switch: true,
    },
  };
  defaultReminder: any = [
    {
      primary: true,
      message: '',
      label: 'tomorrow',
      day: 1,
      time: this.getCurrentSelectedTime().value,
    },
    {
      primary: true,
      message: '',
      label: ': 2 days from now',
      day: 2,
      time: this.getCurrentSelectedTime().value,
    },
  ];
  recipients = {
    emails: [],
    phones: [],
  };
  reminderRecipients = {
    emails: [],
    phones: [],
  };
  isCheckedPreviousUnpaidStatement: Boolean = true;
  reminderRecipientTooltip: string = '';
  notificationRecipientTooltip: string = '';
  useConfirmationRecipient: boolean = false;
  isDownloadingPdf: boolean = false;
  reminders: any[] = [...this.defaultReminder];
  customer: any = {};
  statement: any = {};
  title: string = 'statement';
  company: any = {};
  templateType: string = '';
  inspectionId: string = '';
  subject: string = '';
  content: string = '';
  defaultContent: string = '';
  inspectionTitle: string = '';
  isEmailSelected: boolean = false;
  isSMSSelected: boolean = false;
  isReminderEnabled: boolean = false;
  isDisplayMessage: boolean = false;
  isDisplayFeed: boolean = false;
  logActivity: any;
  times = [];
  reminderTemplate: any = {};
  currentTime: any;
  fleetStatementTemplate: any = {};
  bulkPaymentTemplate: any = {};
  templateKeys = {
    [templateTypes.fleet_statement]: 'fleetStatementTemplate',
    [templateTypes.bulk_payment]: 'bulkPaymentTemplate',
  };
  serverTime: any = 0;
  contacts: any[] = [];
  statementId: string = '';
  paymentId: string = '';
  createAt: any;
  totalDue: number = 0;
  totalPaid: number = 0;
  usd: string = currency.USD;
  isSendingStatement: boolean = false;
  sendType: string = 'statement';
  selectedStatementIds = [];
  @ViewChild('sendDialog', { static: true }) sendDialog: ElementRef;
  previousStatements = [];
  hideUnPaidStatement = false;
  timezones: any = {};
  localizationSubscription: Subscription;
  companyLocalization: boolean = false;
  currentLang: string = 'en';
  customerId: string = '';

  constructor(
    public ref: DynamicDialogRef,
    public dConfig: DynamicDialogConfig,
    public dialogService: DialogService,
    private httpService: HTTPService,
    private helperService: HelperService,
    public dataService: DataService,
    public dateService: DateService,
  ) { }

  async ngOnInit() {
    this.statementId = this.dConfig.data.statementId;
    this.paymentId = this.dConfig.data.bPaymentId;
    this.createAt = this.dConfig.data.createAt;
    this.customerId = this.dConfig.data.customerId;

    this.localizationSubscription = this.dataService.getCompanyLocalization().subscribe((value) => {
      if (value) {
        this.companyLocalization = value
        this.httpService.getCustomerPreferredLanguage(this.customerId).then(res => {
          if (this.companyLocalization) {
            if (res && res.preferredLanguage) {
              this.currentLang = res.preferredLanguage;
              this.getTemplatesAccordingToLanguage();
            }
          }
          else {
            this.currentLang = 'en'
          }
        })
      }
    })

    this.times = time;
    this.hideUnPaidStatement = this.dConfig.data.hideUnPaidStatement;
    if (this.paymentId) {
      this.sendType = 'payment';
      this.title = 'bulk payment receipt';
    }

    try {
      const promises = [this.getTemplates()];

      if (this.sendType === 'payment') {
        promises.push(this.getBulkPayment());
      } else {
        promises.push(this.getStatement());
      }
      const [templateData = {}, data = {}]: any = await Promise.all(promises);
      const { isMultiLocationEnabled, companyId } = this.helperService.getCompany();

      const { templates, company, shop, serverTime } = templateData as any;

      if (this.sendType === 'payment') {
        const { bulkPayment } = data;

        if (bulkPayment && bulkPayment.statementId) {
          this.statement = bulkPayment.statementId;
          this.statement.invoices = bulkPayment.invoices;
          this.statement.customerId = bulkPayment.customerId;
        }
      } else {
        this.statement = data && data.statement;
      }
      this.company = isMultiLocationEnabled ? shop : company;
      this.serverTime = new Date(serverTime);
      this.getStatementList();
      this.populateTemplates(templates);
      this.populateData();
    } catch (err) {
      console.log(err);
    }
  }

  ngOnDestroy(): void {
    if (this.localizationSubscription) this.localizationSubscription.unsubscribe();
  }

  getCustomerContacts() {
    if (!this.customer) return;

    this.httpService.getContactInfo(this.customer.customerId, false, { contactEntityType: 'customer' }).then(
      (contact) => {
        this.useConfirmationRecipient = true;
        if (contact && contact.contactInfo && contact.contactInfo.length) {
          this.setRecipient(contact.contactInfo);
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  // Getting all templates
  getTemplates() {
    return new Promise(async (resolve, reject) => {
      try {
        const { fleet_statement, bulk_payment } = templateTypes;
        const query = { type: [fleet_statement], language: this.currentLang.toUpperCase() };

        if (this.sendType === 'payment') {
          query.type = [bulk_payment];
        }

        const data = await this.httpService.getMultipleTemplates(query, true, { fetchTimezones: true });
        this.timezones = data.timezones;

        resolve(data);
      } catch (err) {
        reject(err);
      }
    });
  }

  switchLanguage() {
    if (this.currentLang === "en") {
      this.currentLang = 'fr';
    } else {
      this.currentLang = 'en';
    }
    this.getTemplatesAccordingToLanguage();
  }

  async getTemplatesAccordingToLanguage() {
    try {
      const promises = [this.getTemplates()];
      const [templateData = {}, data = {}]: any = await Promise.all(promises);
      const { templates } = templateData as any;
      this.populateTemplates(templates);
      this.populateData();
    } catch (err) {
      console.log(err);
    }
  }

  getStatementList() {
    let query = {
      createdAtEnd: null,
      createdAtStart: null,
      customerId: this.statement.customerId._id,
      isPaidFull: null,
      isPaidPartial: true,
      isSent: null,
      isUnpaid: true,
      limit: 1000,
      orderStatus: null,
      skip: 0,
      sortField: 'createdAt',
      sortOrder: -1,
    };
    this.httpService.getStatementList(query).then((x) => {
      this.previousStatements = [];
      let statementList = x.records.filter((statement) => this.statementId !== statement._id);
      statementList.map((statement) => {
        if (statement.invoiceCount && statement.invoiceCount > 0) {
          let statementObj: any = {
            isChecked: false,
            _id: null,
            name: null,
          };
          statementObj.isChecked = false;
          statementObj._id = statement._id;
          statementObj.name = statement.name;
          this.previousStatements.push(statementObj);
        }
      });
    });
  }

  getStatement() {
    if (!this.statementId) return;
    return new Promise(async (resolve, reject) => {
      try {
        const data = await this.httpService.getStatementById(this.statementId, true, true, false);
        resolve(data);
      } catch (err) {
        this.helperService.showToaster('error', err);
        reject(err);
      }
    });
  }

  getBulkPayment() {
    if (!this.paymentId) return;
    return new Promise(async (resolve, reject) => {
      try {
        const data = await this.httpService.getBulkPaymentById(this.paymentId, true);
        resolve(data);
      } catch (err) {
        this.helperService.showToaster('error', err);
        reject(err);
      }
    });
  }

  // Populating all templates
  populateTemplates(templates: any[]) {
    templates.forEach((template) => {
      if (!this.companyLocalization) this.currentLang = 'en'
      if (template.language === this.currentLang.toUpperCase()) {
        const templateKey = this.templateKeys[template.type];
        this[templateKey] = template;
      }
    });
  }

  // Populating the date
  async populateData() {
    if (this.statement && this.statement._id) {
      this.customer = this.statement.customerId;
      this.customer.customerId = this.customer._id;
      this.customer.displayName = this.customer.fullNameQBO;
      this.isEmailSelected = this.customer.contactOnEmail;
      this.isSMSSelected = this.customer.contactOnPhone;
    }

    if (this.statement.startDate) {
      this.statement.startDate = this.dateService.getCurrentDateTimeTz(new Date(this.statement.startDate).getTime());
    }

    if (this.statement.endDate) {
      this.statement.endDate = this.dateService.getCurrentDateTimeTz(new Date(this.statement.endDate).getTime());
    }

    if (this.fleetStatementTemplate) {
      this.subject = this.parseTemplate(this.fleetStatementTemplate.subject);
      this.content = this.parseTemplate(this.fleetStatementTemplate.contents);
    }

    if (this.paymentId && this.bulkPaymentTemplate) {
      this.subject = this.parseTemplate(this.bulkPaymentTemplate.subject);
      this.content = this.parseTemplate(this.bulkPaymentTemplate.contents);
    }

    if (this.statement && this.statement.invoices) {
      this.totalDue = 0;
      this.totalPaid = 0;
      this.statement.invoices.forEach((statement: any) => {
        const { total, cheque, card, cash, creditPayment, thirdParty } = statement;
        statement.paid = cheque + card + cash + creditPayment + thirdParty;
        statement.unpaid = total.grand - statement.paid;
        this.totalDue += statement.unpaid;
        this.totalPaid += statement.paid;
      });
    }

    this.getCustomerContacts();
  }

  /** handle toggling statuses  */
  toggleActiveState(type: string, active: boolean) {
    this[type] = active;

    if (['isEmailSelected', 'isSMSSelected'].includes(type)) {
      this.setRecipient(this.contacts, type);
      return;
    }
  }

  parseTemplate(content: string) {
    const parseData = {
      company: this.company,
      customer: this.customer,
      statement: this.statement,
    };

    return this.helperService.templateParser(content, parseData, false, this.timezones);
  }

  revertParse(content: string) {
    const parseData = {
      company: this.company,
      customer: this.customer,
      statement: this.statement,
    };

    return this.helperService.revertTemplateParsing(content, parseData);
  }

  onSubmit() {
    this.selectedStatementIds = [];
    this.previousStatements.map((prevStatement) => {
      if (prevStatement.isChecked) {
        this.selectedStatementIds.push(prevStatement._id);
      }
    });
    if (!this.isEmailSelected && !this.isSMSSelected) {
      this.helperService.showToaster('error', messages.communicationPreference);
      return;
    }

    const contacts = [...this.recipients.emails, ...this.recipients.phones];

    if (!contacts.length) {
      this.helperService.showToaster('error', 'No contact selected');
      return;
    }

    const data: any = {};
    data.customer = this.customer;
    data.recipients = [...this.recipients.emails, ...this.recipients.phones];
    data.includedStatementIds = this.selectedStatementIds;
    data.companyId = this.company._id;
    data.communication = {
      type: this.sendType === 'payment' ? 'bulkPayment' : 'statement',
      isSMS: this.isSMSSelected,
      isEmail: this.isEmailSelected,
      phone: this.customer && this.customer.phone,
      email: this.customer && this.customer.email,
      subject: this.subject,
      contents: this.content,
    };

    this.sendOrderInvoice(data);
  }

  handleReminderEnableChange(isReminderEnabled: boolean) {
    this.isReminderEnabled = isReminderEnabled;
  }

  sendOrderInvoice(data: any) {
    if (this.isSendingStatement) return;

    this.isSendingStatement = true;
    if (this.sendType === 'payment') {
      this.httpService
        .sendBulkPaymentReceipt(this.paymentId, { ...data })
        .then(
          (res: any) => {
            this.handleClose();
            this.helperService.showToaster('success', 'Reciepts sent');
          },
          (err) => {
            this.helperService.showToaster('error', err);
          },
        )
        .finally(() => {
          this.isSendingStatement = false;
        });
    } else {
      this.httpService
        .sendStatement(this.statementId, { ...data })
        .then(
          (res: any) => {
            this.handleClose();
            this.helperService.showToaster('success', this.sendType === 'payment' ? 'Receipt sent' : 'Statement sent');
          },
          (err) => {
            this.helperService.showToaster('error', err);
          },
        )
        .finally(() => {
          this.isSendingStatement = false;
        });
    }
  }

  /** Scrolling the modal to the bottom */
  scrollToBottom() {
    setTimeout(() => {
      this.sendDialog.nativeElement.scrollTop = this.sendDialog.nativeElement.scrollHeight;
    }, 100);
  }

  deleteReminder(index: number) {
    if (this.reminders && this.reminders.length) {
      this.reminders.splice(index, 1);
    }
  }

  addReminder() {
    if (this.reminders && this.reminders.length) {
      this.reminders.push(this.defaultReminder);
    }
  }

  getCurrentSelectedTime(): any {
    const nowDate = this.helperService.convertDate(new Date());
    const currentHour = nowDate.format('HH');
    const currentMin = nowDate.format('mm');

    if (time) {
      const startHourSlots = time.filter((t) => t.hour === currentHour);

      if (this.helperService.toNumber(currentMin) >= 45) {
        if (this.times) {
          return this.times.filter((t) => t.i === startHourSlots[3].i + 1)[0];
        } else {
          return {};
        }
      } else if (this.helperService.toNumber(currentMin) >= 30 && this.helperService.toNumber(currentMin) < 45) {
        return startHourSlots[3];
      } else if (this.helperService.toNumber(currentMin) >= 15 && this.helperService.toNumber(currentMin) < 30) {
        return startHourSlots[2];
      } else if (this.helperService.toNumber(currentMin) >= 0 && this.helperService.toNumber(currentMin) < 15) {
        return startHourSlots[1];
      }
    }

    return {};
  }

  // Closing the send dialog
  handleClose(data: any = {}) {
    this.ref.close(data);
  }

  openUpdateRecipientDialog(type: string) {
    if (!this.isSMSSelected && !this.isEmailSelected) return;
    if (this.useConfirmationRecipient && type === 'reminder') return;

    let recipients = [];

    if (type === 'confirmation') {
      recipients = [...this.recipients.emails.map(({ value }) => value), ...this.recipients.phones.map(({ value }) => value)];
    } else {
      recipients = [...this.reminderRecipients.emails.map(({ value }) => value), ...this.reminderRecipients.phones.map(({ value }) => value)];
    }

    const ref = this.dialogService.open(UpdateRecipientDialogComponent, {
      closeOnEscape: false,
      width: '650px',
      styleClass: 'add-dialog add-receipt-modal update-contact-dialog',
      showHeader: false,
      data: {
        customerId: this.customer.customerId,
        email: this.customer.email,
        phone: this.customer.phone,
        recipients: this.helperService.deepCopy(recipients),
        contactOnPhone: this.isSMSSelected,
        contactOnEmail: this.isEmailSelected,
        isFleetCustomer: this.customer && this.customer.isFleetCustomer,
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        const recipients = {
          emails: [],
          phones: [],
        };

        if (data.contacts && data.contacts && data.contacts.length) {
          for (let i = 0; i < data.contacts.length; i++) {
            const { _id, value, contactType, isChecked } = data.contacts[i];
            const contact = {
              value,
              recipientId: _id,
              type: contactType,
            };

            if (isChecked) {
              if (contactType === 'email') {
                recipients.emails.push(contact);
              } else {
                recipients.phones.push(contact);
              }
            }
          }
        }

        if (type === 'confirmation') {
          this.recipients = this.helperService.deepCopy(recipients);

          if (this.useConfirmationRecipient) {
            this.reminderRecipients = this.helperService.deepCopy(this.recipients);
          }
        } else {
          this.reminderRecipients = this.helperService.deepCopy(recipients);
        }

        this.notificationRecipientTooltip = this.helperService.createContactTooltip(this.recipients, 'Confirmation');
        this.reminderRecipientTooltip = this.helperService.createContactTooltip(this.reminderRecipients, 'Reminder');
      }

      onClose.unsubscribe();
    });
  }

  setRecipient(contacts: any[], type: string = '') {
    this.contacts = contacts;

    if (!this.isEmailSelected) {
      this.recipients.emails = [];
      this.reminderRecipients.emails = [];
    }

    if (!this.isSMSSelected) {
      this.recipients.phones = [];
      this.reminderRecipients.phones = [];
    }

    if (contacts && contacts.length) {
      contacts.forEach(({ _id, value, contactType, isPrimary }: any) => {
        if (isPrimary) {
          if (contactType === 'email' && this.isEmailSelected && ['', 'isEmailSelected'].includes(type)) {
            this.recipients.emails = [
              {
                type: 'email',
                value: value,
                recipientId: _id,
              },
            ];
          } else if (contactType === 'mobile' && this.isSMSSelected && ['', 'isSMSSelected'].includes(type)) {
            this.recipients.phones = [
              {
                type: 'mobile',
                value: value,
                recipientId: _id,
              },
            ];
          }
        }
      });
    }

    if (this.useConfirmationRecipient) {
      this.reminderRecipients = this.helperService.deepCopy(this.recipients);
    }

    this.notificationRecipientTooltip = this.helperService.createContactTooltip(this.recipients, 'Confirmation');
    this.reminderRecipientTooltip = this.helperService.createContactTooltip(this.reminderRecipients, 'Reminder');
  }

  handleUseConfirmationRecipientChange(useConfirmationRecipient: boolean) {
    this.useConfirmationRecipient = useConfirmationRecipient;

    if (this.useConfirmationRecipient) {
      this.reminderRecipients = this.helperService.deepCopy(this.recipients);
      this.reminderRecipientTooltip = this.helperService.createContactTooltip(this.reminderRecipients, 'Reminder');
    }
  }

  async downloadPdf() {
    this.selectedStatementIds = [];
    if (this.isDownloadingPdf || !this.company._id) return;
    if (this.sendType === 'payment' && !this.paymentId) return;
    if (this.sendType !== 'payment' && !this.statement._id) return;

    this.isDownloadingPdf = true;

    this.previousStatements.map((prevStatement) => {
      if (prevStatement.isChecked) {
        this.selectedStatementIds.push(prevStatement._id);
      }
    });
    try {
      let url = '';

      if (this.sendType === 'payment') {
        url = await this.httpService.downloadBulkPaymentPdf(this.paymentId);
      } else {
        url = await this.httpService.downloadStatementPdf(this.company._id, this.statement._id, { includedStatementIds: this.selectedStatementIds });
      }

      window.open(url, '_blank');
    } catch (err) {
      this.helperService.showToaster('error', err);
    } finally {
      this.isDownloadingPdf = false;
    }
  }

  onSelectStatement(statement: any, isChecked: boolean) {
    if (isChecked) {
      statement.isChecked = true;
    } else {
      statement.isChecked = false;
    }
  }

  toggleAccordianState() {
    this.isCheckedPreviousUnpaidStatement = !this.isCheckedPreviousUnpaidStatement;
  }
}
